import React, { useContext, useEffect, useState } from "react";
import FormDataContext from "integrations/contexts/FormDataContext";
import useFetch from "integrations/hooks/useFetch";
import urlWithAuthParams from "enterprise-integrations/helpers/urlWithAuthParams";
import { ApiRoutes } from "./common/Routes";
import formValidation from "./utils/formValidation";
import FormWrap from "../common/FormWrap";
import ValidatedInput from "../common/ValidatedInput";
import { renderOptions } from "../common/Options";
const StepAuthorize = ({ onSubmit, onChange }) => {
  var _a, _b, _c, _d;
  const { formData } = useContext(FormDataContext);
  const [formError, setFormError] = useState(null);
  const { clientSecret } = formData;
  const subscriptions = [
    { label: "Global Service", value: "GLOBAL" },
    { label: "US Government", value: "US_GOV" },
    { label: "US DOD", value: "US_DOD" }
  ];
  const [DefenderValidationStatus, setDefenderValidation] = useFetch(
    null,
    onSubmit,
    "POST",
    {
      defender_tenant_id: ((_a = formData == null ? void 0 : formData.tenantId) == null ? void 0 : _a.value) || "",
      defender_client_id: ((_b = formData == null ? void 0 : formData.clientId) == null ? void 0 : _b.value) || "",
      defender_client_secret: ((_c = formData == null ? void 0 : formData.clientSecret) == null ? void 0 : _c.value) || "",
      defender_subscription_type: ((_d = formData == null ? void 0 : formData.subscriptionType) == null ? void 0 : _d.value) || ""
    },
    urlWithAuthParams
  );
  useEffect(() => {
    setDefenderValidation(null);
    if (DefenderValidationStatus.error) {
      setFormError({
        full_message: DefenderValidationStatus.error,
        nice_message: "Unable to connect to Microsoft Defender using provided configuration."
      });
    }
    return () => {
      setFormError(null);
    };
  }, [DefenderValidationStatus.error, setDefenderValidation]);
  const handleSubmit = () => {
    setDefenderValidation(ApiRoutes.INTEGRATIONS.Defender.CHECK_CREDENTIALS);
  };
  const isFormValid = formValidation.isFormValid(
    ["defenderName", "tenantId", "clientId", "clientSecret", "subscriptionType"],
    formData
  );
  return /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: handleSubmit,
      buttonContent: "Verify Connection & Proceed",
      disabled: isFormValid,
      loading: DefenderValidationStatus.loading,
      title: "",
      error: formError,
      description: ""
    },
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "defenderName",
        type: "text",
        fieldData: formData.defenderName,
        onChange,
        placeholder: "Input Name",
        label: "Input Name",
        autoComplete: "off",
        help: "Select a name of your new input that describes it.",
        defaultValue: clientSecret == null ? void 0 : clientSecret.value,
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "tenantId",
        type: "text",
        fieldData: formData.tenantId,
        onChange,
        label: "Directory (tenant) ID",
        help: "The GUID of the tenant to which the content belongs.",
        autoComplete: "off",
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "clientId",
        type: "text",
        onChange,
        fieldData: formData.clientId,
        help: "The GUID of your application that created the subscription.",
        label: "Application (client) ID",
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "clientSecret",
        type: "password",
        onChange,
        fieldData: formData.clientSecret,
        label: "Client Secret",
        help: "A secret string that the application uses to prove its identity when requesting a token.",
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        type: "select",
        name: "subscriptionType",
        id: "subscriptionType",
        onChange,
        fieldData: formData.subscriptionType,
        help: "Azure subscription type for your organization.",
        required: true,
        label: "Subscription Type"
      },
      renderOptions(subscriptions, "Choose a Subscription")
    )
  );
};
export default StepAuthorize;
